export default "__VITE_ASSET__BqOSVcWI__"